import { EventDateTimeExposure } from './EventDateTimeExposure';

export default EventDateTimeExposure;
